import { defineComponent } from "vue";
import { u as useTreeView } from "./hooks/useTreeView-85346171.mjs";
import { u as useTreeViewProps, a as useTreeViewEmits } from "./hooks/useTreeHelpers-f48ba030.mjs";
import { V as VaTreeNode } from "./components/VaTreeNode/index-f68e8a08.mjs";
const _sfc_main = defineComponent({
  name: "VaTreeView",
  props: { ...useTreeViewProps },
  emits: [...useTreeViewEmits],
  components: { VaTreeNode },
  setup: (props, { emit }) => {
    const { treeItems, getTrackBy } = useTreeView(props, emit);
    return { treeItems, getTrackBy };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaTreeView.vue_vue_type_script_lang-e43009b5.mjs.map
